(ns dre.modals.app-settings.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.modals.events :as-alias modals]
   [dre.network :as-alias network]
   [dre.pages.my-searches.tags.events :as t-events]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path
  [:modals :app :settings])

;; events

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} _]
  {:db {:state :loading}
   ::network/request [{:endpoint :app/settings}
                      {:on-success [::init-success]}]}))

(rf/reg-event-fx
 ::init-success
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  {:db (-> db
           (assoc-in [:state] :success)
           (assoc-in [:settings] (:body response))
           (assoc-in [:set-existing-signals?] false))}))

(rf/reg-event-fx
 ::save
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} _]
  {::network/request [{:endpoint :app/save-settings}
                      {:body {:settings (select-keys (get-in db [:settings]) [:signals])
                              :set-existing-signals? (get-in db [:set-existing-signals?])}
                              :on-success [::save-success]}]}))

(rf/reg-event-fx
 ::save-success
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  {:dispatch [::modals/clear]}))

(rf/reg-event-fx
 ::update-data
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [path value]]
  {:db (assoc-in db path value)}))

;; subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))

